import { TKV2_ORDER_ATTACHMENT_API, Tkv2MarketConditionsAttachment } from '@aloft/toolkit-shared';
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { fetchGetTkv2MarketConditionsAPI } from '../../hooks/api/toolkitComponents.ts';
import { useToolkitContext } from '../../hooks/api/toolkitContext.ts';

export const useTkv2MarketConditions = (
  params: { pathParams: { orderID: string } },
  opts?: Omit<UseQueryOptions<Tkv2MarketConditionsAttachment>, 'queryKey' | 'queryFn'>,
): UseQueryResult<Tkv2MarketConditionsAttachment> => {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Tkv2MarketConditionsAttachment>({
    queryKey: ['order', params.pathParams.orderID, 'marketConditions'],
    queryFn: async () => {
      const res = await fetchGetTkv2MarketConditionsAPI({ ...fetcherOptions, ...params });
      return TKV2_ORDER_ATTACHMENT_API.MARKET_CONDITIONS.GET.RESPONSE.parse(res);
    },
    ...opts,
  });
};
